import React, { useEffect, useRef, useState } from 'react'
import InputMask from 'react-input-mask'

import { InputNumberProps } from './InputNumberProps'
import { AutocompleteValues, InputModes } from 'models/Form/FieldsModels'
import { numberToDisplayString } from 'common/helpers/numberHelpers'
import analyticsService from 'service/AnalyticsService/AnalyticsService'
import { AnalyticsActionTypes } from 'service/AnalyticsService/AnalyticsServiceModels'


const InputNumber = React.memo((props: InputNumberProps) => {

   const { field, isFirstFill, handleSetIsFieldFirstFill } = props
   const [value, setValue] = useState<string>(props.value as string)
   const hasPageBeenRendered = useRef(false)

   const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const forbidenChars = [".", ",", "+", "-", "e"] //Wartość pola ma być liczbą naturalną, więc nie pozwalamy używać przecinka, kropki, ani minusa
   
      if (forbidenChars.includes(e.key)) { 
         e.preventDefault() //Blokuje możliwość wpisania danej wartości do kontrolki  
      } 
   } 

   const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const currentValue = e.target.value

      if(currentValue === undefined || currentValue.startsWith('0')){
         return
      }

      const parsedValue = currentValue.replace(/[^0-9]/g, "")
      setValue(parsedValue)
   }

   const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      if (isFirstFill && value.length > 0) { // Jeśli pole jest wypełnione po raz pierwszy oraz posiada jakąkolwiek wartość wysyłamy zdarzenie analityczne do bazy
         analyticsService.sendAnalyticAction(field.label, AnalyticsActionTypes.FieldFilledActionId)
         handleSetIsFieldFirstFill(field.name)
      }
      else if (!isFirstFill) { // Jeśli pole BYŁO JUŻ WYPEŁNIONE (AKTUALIZACJA POLA) - w tym przypadku pole nie musi posiadać wartości - użytkownik mógł zaktualizować na pustą wartość
         analyticsService.sendAnalyticAction(field.label, AnalyticsActionTypes.FieldUpdateActionId)
      }
      
      const currentInputValue = e.target.value
      props.handleValidateField(field.name, currentInputValue, field.validation)
      props.field.onBlurHandler && props.field.onBlurHandler(currentInputValue)
   }

   useEffect(() => { //Debounce input
      const timeoutId = setTimeout(() => {
         if(hasPageBeenRendered.current){ //Pierwsze błedy walidacyjne wyświetlamy dopiero gdy użytkownik zacznie uzupełniać kontrolki
            props.handleSaveInputValueToState(field.name, value, field.validation)
            props.handleValidateField(field.name, value, field.validation)
            return
         }

         hasPageBeenRendered.current = true // Pierwszy render strony - nie chcemy od razu wyświetlać wszystkich błędów walidacyjnych
      }, props.debounceTime)

      return () => clearTimeout(timeoutId)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, hasPageBeenRendered]);


   return (
      <InputMask
         id={field.name}
         name={field.name}
         autoComplete={field.browserAutocomplete ?? AutocompleteValues.On}
         inputMode={field.inputMode ?? InputModes.numeric}
         value={numberToDisplayString(value, "", true)}
         mask={field.mask || ''}
         maxLength={!field.mask ? field.maxLength : undefined} //Jeśli jest maska ona określa ile znaków można wpisać w kontrolkę. Jeśli nie ma maski i nie ma "maxLength" nie ma limitu wpisywanych znaków
         maskChar={''}
         onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e)}
         onBlur={(e: React.FocusEvent<HTMLInputElement>) => handleOnBlur(e)}
         onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => handleOnKeyDown(e)}
         onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => props.handlePasteDisabled(e, field.isPasteDisabled)}
         type="text"
         placeholder={field.placeholder}
      />
   )
})

export default InputNumber